import { c as _c } from "react/compiler-runtime";
import { FullWidthBanner } from '@systemeio/components';
import React from 'react';
import { useSetDefaultEmailOptions } from 'shared/components/dashboard-mail-editor/hooks/use-set-default-email-options';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twMerge } from 'tailwind-merge';
import AttachmentsBlock from './components/attachments-block';
import EditorBlock from './components/editor-block';
import EmailSettingsBlock from './components/email-settings-block';
import { MailEditorSidebarTabs } from './components/mail-editor-sidebar-tabs';
import SubstitutesBlock from './components/substitutes-block';
import { DashboardMailEditorProps, ExtendedState } from './types/common';
const DashboardMailEditor = t0 => {
  const $ = _c(60);
  const {
    additionalSubstitutes,
    sidebarTabs: t1,
    attachmentsTempState,
    errors,
    inModal,
    disabled,
    isPreFetching,
    isSwitchEditorButtonShown,
    onChangeEmail,
    setAttachmentsTempState,
    showSettingsLink,
    tempState,
    withRecipient,
    mailingId,
    withoutAttachments
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const sidebarTabs = t2;
  const {
    t
  } = useLocoTranslation();
  let t3;
  if ($[2] !== withRecipient) {
    t3 = {
      withRecipient
    };
    $[2] = withRecipient;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    isOptionsApplied
  } = useSetDefaultEmailOptions(tempState, onChangeEmail, t3);
  let t4;
  if ($[4] !== attachmentsTempState || $[5] !== disabled || $[6] !== errors.attachments || $[7] !== inModal || $[8] !== isPreFetching || $[9] !== mailingId || $[10] !== setAttachmentsTempState || $[11] !== t || $[12] !== withoutAttachments) {
    t4 = !withoutAttachments ? [{
      Component: <AttachmentsBlock disabled={disabled} isPreFetching={isPreFetching} attachmentsTempState={attachmentsTempState} setAttachmentsTempState={setAttachmentsTempState} inModal={inModal} mailingId={mailingId} errors={errors?.attachments} />,
      showErrorOutline: Boolean(errors?.attachments),
      title: t("dashboard.email.attachments"),
      value: "attachments"
    }] : [];
    $[4] = attachmentsTempState;
    $[5] = disabled;
    $[6] = errors.attachments;
    $[7] = inModal;
    $[8] = isPreFetching;
    $[9] = mailingId;
    $[10] = setAttachmentsTempState;
    $[11] = t;
    $[12] = withoutAttachments;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== additionalSubstitutes || $[15] !== inModal) {
    t5 = <SubstitutesBlock inModal={inModal} additionalSubstitutes={additionalSubstitutes} />;
    $[14] = additionalSubstitutes;
    $[15] = inModal;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] !== t) {
    t6 = t("dashboard.email.personalization");
    $[17] = t;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t5 || $[20] !== t6) {
    t7 = {
      Component: t5,
      title: t6,
      value: "personalization"
    };
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== sidebarTabs || $[23] !== t4 || $[24] !== t7) {
    t8 = [...sidebarTabs, ...t4, t7];
    $[22] = sidebarTabs;
    $[23] = t4;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  const tabs = t8;
  let t9;
  if ($[26] !== errors.common) {
    t9 = errors.common.length > 0 && <FullWidthBanner variant="error">{errors.common.map(_temp)}</FullWidthBanner>;
    $[26] = errors.common;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  const t10 = isPreFetching || !isOptionsApplied;
  let t11;
  if ($[28] !== disabled || $[29] !== errors || $[30] !== inModal || $[31] !== onChangeEmail || $[32] !== t10 || $[33] !== tempState) {
    t11 = <EmailSettingsBlock disabled={disabled} isPreFetching={t10} tempState={tempState} onChangeEmail={onChangeEmail} inModal={inModal} errors={errors} />;
    $[28] = disabled;
    $[29] = errors;
    $[30] = inModal;
    $[31] = onChangeEmail;
    $[32] = t10;
    $[33] = tempState;
    $[34] = t11;
  } else {
    t11 = $[34];
  }
  const t12 = isPreFetching || !isOptionsApplied;
  let t13;
  if ($[35] !== additionalSubstitutes || $[36] !== disabled || $[37] !== errors || $[38] !== isSwitchEditorButtonShown || $[39] !== mailingId || $[40] !== onChangeEmail || $[41] !== showSettingsLink || $[42] !== t12 || $[43] !== tempState || $[44] !== withRecipient) {
    t13 = <EditorBlock additionalSubstitutes={additionalSubstitutes} isSwitchEditorButtonShown={isSwitchEditorButtonShown} isPreFetching={t12} disabled={disabled} tempState={tempState} withRecipient={withRecipient} onChangeEmail={onChangeEmail} errors={errors} showSettingsLink={showSettingsLink} mailingId={mailingId} />;
    $[35] = additionalSubstitutes;
    $[36] = disabled;
    $[37] = errors;
    $[38] = isSwitchEditorButtonShown;
    $[39] = mailingId;
    $[40] = onChangeEmail;
    $[41] = showSettingsLink;
    $[42] = t12;
    $[43] = tempState;
    $[44] = withRecipient;
    $[45] = t13;
  } else {
    t13 = $[45];
  }
  let t14;
  if ($[46] !== t11 || $[47] !== t13 || $[48] !== t9) {
    t14 = <div className="flex w-full min-w-0 flex-col gap-4">{t9}{t11}{t13}</div>;
    $[46] = t11;
    $[47] = t13;
    $[48] = t9;
    $[49] = t14;
  } else {
    t14 = $[49];
  }
  const t15 = inModal && "desktop:static";
  let t16;
  if ($[50] !== t15) {
    t16 = twMerge("desktop:sticky desktop:w-100 static top-(--sticky-top) flex h-fit w-full flex-col gap-5", t15);
    $[50] = t15;
    $[51] = t16;
  } else {
    t16 = $[51];
  }
  let t17;
  if ($[52] !== tabs) {
    t17 = <MailEditorSidebarTabs tabs={tabs} />;
    $[52] = tabs;
    $[53] = t17;
  } else {
    t17 = $[53];
  }
  let t18;
  if ($[54] !== t16 || $[55] !== t17) {
    t18 = <div className={t16}>{t17}</div>;
    $[54] = t16;
    $[55] = t17;
    $[56] = t18;
  } else {
    t18 = $[56];
  }
  let t19;
  if ($[57] !== t14 || $[58] !== t18) {
    t19 = <div className="desktop:flex-row desktop:gap-8 flex flex-col gap-4">{t14}{t18}</div>;
    $[57] = t14;
    $[58] = t18;
    $[59] = t19;
  } else {
    t19 = $[59];
  }
  return t19;
};
export default DashboardMailEditor;
function _temp(error, index) {
  return <p className="text-text-error" key={index}>{error}</p>;
}